enum AlertTypes {
  success = 0,
  error = 1,
  warning = 2,
}

export default AlertTypes;
